import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AppSettings } from './constants';
import { ColorifyDateDirective, DurationPickerDirective } from './directives';
import { MatIconDescriptorDirective } from './directives/mat-icon-descriptor.directive';
import { ClientNotificationHandlerService } from './errors';
import { GlobalErrorHandler } from './errors/global-error-handler';
import { AuthenticationGuard, PreAuthenticationGuard, RoleGuard } from './guards';
import { CustomMatPaginatorIntl } from './mat-components/custom-paginator-intl';
import {
  EmptyFieldPipe,
  FormatFileSizePipe,
  FormatFileTypesPipe,
  ImageLoadingPipe,
  LineBreakPipe,
  OptionsLabelPipe,
  OptionsTooltipPipe,
  SafePipe,
  SpDateFormatPipe,
  SpTimeFormatPipe,
  TagNamePipe,
  TruncatePipe,
} from './pipes';
import { DateNotExpiredPipe } from './pipes/date-not-expired.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { AppVersionService, InformationBannerService, NavigationItemsService } from './services';
import { NotificationComponent } from './services/notification.service';
import { RouterHistoryService } from './services/router-history.service';
import { ValueListsService } from './services/value-lists.service';
import { CanNotPipe, CanPipe } from './user-access/can.pipe';
import { HasGlobalRolePipe } from './user-access/has-global-role.pipe';
import { AuthenticationLib, CryptoJSUtilityLib, DateUtilityLib, RedirectionUtilityLib, StorageUtilityLib } from './util';

@NgModule({
  imports: [CommonModule, HttpClientModule, MatIconDescriptorDirective],
  declarations: [
    CanPipe,
    CanNotPipe,
    HasGlobalRolePipe,
    SafePipe,
    EmptyFieldPipe,
    SpDateFormatPipe,
    LineBreakPipe,
    SpTimeFormatPipe,
    TruncatePipe,
    FormatFileSizePipe,
    DateNotExpiredPipe,
    ImageLoadingPipe,
    NotificationComponent,
    ReplacePipe,
    ColorifyDateDirective,
    OptionsLabelPipe,
    OptionsTooltipPipe,
    LineBreakPipe,
    FormatFileTypesPipe,
    DurationPickerDirective,
    TagNamePipe,
  ],
  exports: [
    CanPipe,
    CanNotPipe,
    HasGlobalRolePipe,
    SafePipe,
    EmptyFieldPipe,
    SpDateFormatPipe,
    SpTimeFormatPipe,
    TruncatePipe,
    LineBreakPipe,
    FormatFileSizePipe,
    DateNotExpiredPipe,
    ImageLoadingPipe,
    ReplacePipe,
    ColorifyDateDirective,
    MatIconDescriptorDirective,
    OptionsLabelPipe,
    OptionsTooltipPipe,
    FormatFileTypesPipe,
    DurationPickerDirective,
    TagNamePipe,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    PreAuthenticationGuard,
    AuthenticationGuard,
    RoleGuard,
    RedirectionUtilityLib,
    AuthenticationLib,
    CryptoJSUtilityLib,
    StorageUtilityLib,
    AppSettings,
    ValueListsService,
    RouterHistoryService,
    DateUtilityLib,
    ClientNotificationHandlerService,
    AppVersionService,
    SpDateFormatPipe,
    FormatFileSizePipe,
    DateNotExpiredPipe,
    SafePipe,
    InformationBannerService,
    NavigationItemsService,
  ],
})
export class ClientCoreModule {}
